import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: "Company",
      links: [
        { label: "Contact", href: "mailto:dawglabsapp@gmail.com" },
      ],
    },
    {
      title: "Products",
      links: [
        {
          label: "DAWG App",
          href: "https://apps.apple.com/us/app/dawg-discipline-motivation/id6742336314",
        },
        {
          label: "Mio App",
          href: "https://apps.apple.com/app/id6783861950",
        },
        {
          label: "Trueform App",
          href: "https://apps.apple.com/us/app/trueform-stretch-mobility/id6783914054",
        },
        {
          label: "SwingSight App",
          href: "/#swingsight",
        },
      ],
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-text">DWG</span>
              <span className="logo-accent">LABS</span>
            </Link>
            <p className="footer-tagline">
              Building elite apps for those who refuse to settle.
            </p>

            {/* Social media links - update with real URLs when available */}
            {/* <div className="footer-social">
              <a href="https://twitter.com/dwglabs" className="social-link" aria-label="Twitter" target="_blank" rel="noopener noreferrer">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
            </div> */}
          </div>

          <div className="footer-links">
            {footerLinks.map((group, index) => (
              <div className="footer-link-group" key={index}>
                <h4 className="link-group-title">{group.title}</h4>
                <ul className="link-list">
                  {group.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <a href={link.href} className="footer-link">
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            © {currentYear} DWG Labs LLC. All rights reserved.
          </div>
          <div className="footer-tagline-bottom">
            <span className="gold">DONE WITH GREATNESS</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
